import { render, staticRenderFns } from "./AppTextArea.vue?vue&type=template&id=0d4cb392&"
import script from "./AppTextArea.vue?vue&type=script&lang=ts&"
export * from "./AppTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./AppTextArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
